// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
var text_fields = {};
var select_fields = {};
import 'core-js';
import 'regenerator-runtime/runtime';

require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require('jquery')
require('modules/featherlight')
require('modules/gdpr')
require('modules/marketing-mobile')
require('modules/marketing-calculator')

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
// Support component names relative to this directory:

import '../stylesheets/marketing.scss'

$(function() {
  if($('.snackbar').length) {
    $('.snackbar').addClass('snackbar-opened');
    setTimeout(function() {
      $('.snackbar').removeClass('snackbar-opened');
    }, 10000);
  }
});
